import React, { useEffect, useState } from "react";
import SessionsPerLanguageChart from "../UI/SessionsPerLanguageChart";
import MoneySpentPerLanguageChart from "../UI/MoneySpentPerLanguageChart";
import UsersPerLanguageChart from "../UI/UsersPerLanguageChart";
import { getCostPerLanguageData, getLanguageData, getUsersPerLanguageData } from "../../requests";
import { deleteAuthToken } from "../../utils/helper";


const Languages = () => {
  const [languagesData, setLanguagesData] = useState([]);
  const [usersPerLanguageData, setUsersPerLanguageData] = useState([]);
  const [costPerLanguageData, setCostPerLanguageData] = useState([]);

  useEffect(() => {
    fetchLanguagesData();
  }, []);

  const fetchLanguagesData = async () => {
    try {
      const response = await getLanguageData();
      const response2 = await getUsersPerLanguageData();
      const response3 = await getCostPerLanguageData();

      const costPerLanguageData = response3.data.costData;
      const languagesData = response.data.languages;
      const usersPerLanguageData = response2.data.languages;

      setLanguagesData(languagesData);
      setUsersPerLanguageData(usersPerLanguageData);
      setCostPerLanguageData(costPerLanguageData);
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      console.error("Error in sending message:", error);
    }
  };
  return (
    <>
      <h4 className="hm-section-title">LANGUAGE</h4>
      <div
        className="languages-charts-row"
        style={{
          display: "flex",
          gap: 32,
          justifyContent: "space-between",
          margin: "32px 0",
        }}
      >
        <SessionsPerLanguageChart data={languagesData} />
        <MoneySpentPerLanguageChart data={costPerLanguageData} />
        <UsersPerLanguageChart data={usersPerLanguageData} />
      </div>
    </>
  );
};

export default Languages;
